import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import PALETTE from 'react/shared/theme/palette';

export default function CardIcon(props) {
  return (
    <SvgIcon alt="True Link Card Icon" viewBox="0 0 24 18" {...props}>
      <path
        clipRule="evenodd"
        d="M1.98347 0.0909424H22.0165C23.112 0.0909424 24 1.06778 24 2.27276V15.3637C24 16.5687 23.112 17.5455 22.0165 17.5455H1.98347C0.88803 17.5455 0 16.5687 0 15.3637V2.27276C0 1.06778 0.88803 0.0909424 1.98347 0.0909424ZM2.18203 7.72725V15.3637H21.8184V7.72725H2.18203ZM2.18203 5.54543H21.8184V2.27278H2.18203V5.54543Z"
        fill={PALETTE.emerald}
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}
